import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';
import theme from 'components/theme';
import Button from 'components/Button';

export const StyledPackList = styled.div`
  background: ${theme.colors.black};
  display: grid;
  gap: 40px;
  justify-items: stretch;
  padding: 24px 20px 0;

  @media (min-width: 480px) {
    justify-items: center;
  }

  ${mediaDesktop} {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0;
  }
`;

export const StyledWrapper = styled.section`
  padding-top: 25px;
  background: ${theme.colors.black};
  padding-bottom: 20px;
  ${mediaDesktop} {
    padding-bottom: 0;
  }
`;

export const PackButtonStyled = styled(Button)`
  padding: 8px 11px 8px;
  font-weight: 600;
  opacity: 1;

  ${mediaDesktop} {
    margin-left: 26px;
    padding: 7px 11px;
    letter-spacing: 2px;
  }
`;

export const PopUpText = styled.div`
  font-family: ${theme.fonts.secondary};
  font-size: 30px;
  letter-spacing: 1px;
  font-weight: 600;
  text-align: center;
  padding-bottom: 8px;

  ${mediaDesktop} {
    padding-bottom: 50px;
  }
`;

export const CountdownHeadline = styled.h3`
  margin: 16px 0 15px;
  color: ${theme.colors.primary};
  font-family: ${theme.fonts.secondary}, sans-serif;
  font-size: 21px;
  letter-spacing: 1px;
  font-weight: lighter;

  ${mediaDesktop} {
    margin: 3px 0 14px;
    letter-spacing: 1.5px;
    font-size: 30px;
  }
`;

export const CountdownNumberRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 30px;

  ${mediaDesktop} {
    column-gap: 28px;
  }
`;

export const CountdownNumberBox = styled.div`
  border: 1px solid ${theme.colors.primary};
  color: ${theme.colors.white};
  width: 48px;
  height: 48px;
  padding-top: 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${theme.fonts.secondary}, sans-serif;
  font-size: 31px;
  letter-spacing: 1px;
  text-align: center;
  color: ${theme.colors.primary};
  font-weight: lighter;

  ${mediaDesktop} {
    width: 50px;
    height: 50px;
    border-width: 2px;
    border-color: ${theme.colors.primary};
    font-size: 40px;
  }
`;

export const CountdownNumberLabel = styled.h5`
  margin-top: 10px;
  letter-spacing: 1px;
  color: ${theme.colors.primary};
  text-align: center;
  font-family: ${theme.fonts.secondary}, sans-serif;
  font-weight: lighter;
  font-size: 13px;

  ${mediaDesktop} {
    margin-top: 16px;
    font-size: 16px;
    letter-spacing: 1px;
  }
`;

export const CountdownWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  width: 100%;
  height: 151px;
  background: transparent;

  ${mediaDesktop} {
    height: 200px;
  }
`;
